import { useState } from 'react'
import { Card, CardBody, CardText, Row, Col, Collapse, Badge } from 'reactstrap'
import moment from 'moment-timezone'
import { startCase } from 'lodash'

function formatDateTime(datetime, timezone) {
    if (!datetime || !timezone) return '--'
    const hasOffset = datetime.endsWith('Z') || /[+-]\d{2}:?\d{2}$/.test(datetime)
    const m = hasOffset ? moment.parseZone(datetime) : moment.tz(datetime, timezone)
    if (!m.isValid()) return '--'
    return m.tz(timezone).format('MMM D, YYYY h:mm A z')
}

function TripCard({ trip, timezone }) {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => setIsOpen(!isOpen)

    const startDatetime = formatDateTime(trip.startDatetime, timezone) || '--'
    const endDatetime = formatDateTime(trip.endDatetime, timezone) || '--'
    const startLocation = trip.startLocationFormattedAddress || '--'
    const endLocation = trip.endLocationFormattedAddress || '--'
    const status = startCase(trip.status) || '--'
    const employer = startCase(trip.employer) || '--'
    const type = startCase(trip.type) || '--'
    const income = (trip.incomeCurrency && trip.incomeTotal != null)
        ? `${trip.incomeCurrency} ${trip.incomeTotal.toFixed(2)}`
        : '--'
    const distance = (trip.distance != null)
        ? `${trip.distance} ${trip.distanceUnit || ''}`
        : '--'

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'completed':
                return 'success'
            case 'in_progress':
                return 'secondary'
            case 'cancelled':
                return 'danger'
            default:
                return 'light'
        }
    }

    return (
        <Card
            onClick={toggle}
            className="mb-2 shadow-sm border-light"
            style={{ borderRadius: '12px', cursor: 'pointer' }}
        >
            <CardBody>
                <Row className="align-items-center mb-2">
                    <Col xs={5}>{startDatetime}</Col>
                    <Col xs={3}>{income}</Col>
                    <Col xs={2}>{employer}</Col>
                    <Col xs={2}>
                        <Badge color={getStatusColor(status)}>{status}</Badge>
                    </Col>
                </Row>
                <Collapse isOpen={isOpen}>
                    <hr />
                    <Row>
                        <Col md={6}>
                            <CardText><strong>Start:</strong> {startDatetime}</CardText>
                            <CardText><strong>End:</strong> {endDatetime}</CardText>
                            <CardText><strong>Distance:</strong> {distance}</CardText>
                            <CardText><strong>Type:</strong> {type}</CardText>
                        </Col>
                        <Col md={6}>
                            <CardText>
                                <strong>Start Location:</strong><br />
                                <span className="text-muted small">{startLocation}</span>
                            </CardText>
                            <CardText>
                                <strong>End Location:</strong><br />
                                <span className="text-muted small">{endLocation}</span>
                            </CardText>
                        </Col>
                    </Row>
                </Collapse>
            </CardBody>
        </Card>
    )
}

export default TripCard
